/**
 * app > store > cm
 *     > securityPolicy > network
 *     > protectionDomain 보호 도메인
 *
 * @created at 2021-09-01
 * @created by wj_tams_dev06
 */

import {CmApiPrefix} from '~/utils/restApi'

const urlPrefix = `${CmApiPrefix}`

const pdDataTemplate = {
  pd_name: '',
  pd_desc: '', // ads에서 사용하지 않는 컬럼
  pd_use: 1,
  pd_type: 1,
  pd_host: [],
  pd_geo_country: [],
  pd_vlan: '',
  pd_ips_sig_use: 1,
  pd_ips_ddos_use: 1,
  pd_ips_learn_use: 0,
  pd_ips_auth_use: 0,
  pd_ips_prf_direct: 0,
  pd_ips_prf_id1: 0,
  pd_ips_prf_id2: 0,
  pd_ips_prf_action: 1,
  // pd_apt_use: 0, // ips
  // pd_port_awr_use: 0, // ips
  pd_qos_dynamic_use: 0,
  pd_qos_static_use: 0,
  // pd_reso_awr_use: 0, // ips
  // pd_dns_sec_use: 0, // ads
  pd_ssl_awr_use: 0,
  pd_ssl_inline_use: 0,
  pd_ssl_proxy_use: 0,
  pd_x_header_use: 0
}

const applyActivationOption = ({data, bluemaxModelType}) => {
  const cntObj = {
    totalCnt: 0,
    enableCnt: 0,
    disableCnt: 0
  }
  const finalArr = []
  /** Minimal garbage creation: A. set array length, B.assign value afterwards */
  data.forEach((item, parentIdx) => {
    const groupName = _.get(item, 'pd_grp_name')
    const isInheritGroup = (groupName === 'inherit')

    /** 1. SET tableGroupName (Required) */
    item.name = groupName
    item.is_inherit = isInheritGroup
    item.parent_id = `${groupName}${parentIdx}`
    const newObj = {}
    Object.keys(item).forEach(key => {
      if (key !== 'pd') {
        newObj[key] = item[key]
      }
    })
    finalArr.push(newObj)

    if (_.size(_.get(item, 'pd')) > 0) {
      /** 2. calculate totalCnt */
      item.pd.forEach(child => {
        if (_.get(child, 'pd_use') === 1) {
          cntObj.enableCnt += 1
        }
        cntObj.totalCnt += 1
        child.is_inherit = isInheritGroup

        /** IMPORTANT: reAssign children's pd_grp_id === parent's pd_grp_id (grouping purpose) */
        child.parent_id = `${groupName}${parentIdx}`

        if (child.pd_type === 1) {
          child.pd_host.forEach(x => {
            x.name = x.addr_obj_uname
          })
          child.protect_object = child.pd_host
        } else if (child.pd_type === 4) {
          child.pd_geo_country.forEach(item => {
            item.code = item.geo_country_code
            item.name = item.geo_country_name
            delete item.geo_country_code
            delete item.geo_country_name
          })
          child.protect_object = child.pd_geo_country
        } else {
          if (child.pd_vlan.includes(',')) {
            const splitted = child.pd_vlan.split(',')
            child.protect_object = splitted.map(x => {
              return {
                name: x
              }
            })
          } else {
            child.protect_object = [{name: child.pd_vlan}]
          }
        }

        const prfName = bluemaxModelType === 'ips' ? 'ngips_prf_name' : 'ads_ips_prf_name'

        /** 침임탐지_프로파일 IPS */
        if (_.has(child, 'pd_ips_prf_direct')) {
          const inbound = _.get(child, `pd_ips_prf_id1.${prfName}`)
          child.pd_ips_prf = []
          const outbound = _.get(child, `pd_ips_prf_id2.${prfName}`)
          if (child.pd_ips_prf_direct === 0 && inbound) child.pd_ips_prf.push({direct: 0, name: inbound})
          else if (child.pd_ips_prf_direct === 0) child.pd_ips_prf.push({direct: 0, name: 'default'})
          else {
            child.pd_ips_prf.push({direct: 1, name: inbound})
            child.pd_ips_prf.push({direct: 2, name: outbound})
          }
        }
        child.protect_option = []
        /** 옵션 (pd_port_awr_use) IPS */
        if (bluemaxModelType === 'ips' && _.get(child, 'pd_port_awr_use')) {
          child.protect_option.push({
            name: 'po.protection_domain_port_recognition',
            val: child.pd_port_awr_use
          })
        }
        /** 옵션 (pd_x_header_use) IPS, ADS */
        if (_.get(child, 'pd_x_header_use')) {
          child.protect_option.push({
            name: 'po.protection_domain_x_header',
            val: child.pd_x_header_use
          })
        }
        child.use = child.pd_use // pd_use {1: enable, 2: disable}
        finalArr.push(child)
      })
    }
  })
  /** 3. SET row count info  */
  cntObj.disableCnt = cntObj.totalCnt - cntObj.enableCnt
  return {list: finalArr, cntInfo: cntObj}
}

export const state = () => ({
  bluemaxModelType: '',
  ipsDeviceType: 21,
  storeReadOnly: true,
  isSelectCell: false,
  /** tableInfo */
  pdTableData: [],
  cntInfo: {
    totalCnt: 0,
    enableCnt: 0,
    disableCnt: 0
  },
  /** disable,1: enable, 2: showAll */
  policyViewFilter: 2,
  pdForm: null,
  selectedDeviceInfo: {},
  selectedPdData: [],
  policyHostList: [],
  popUpFunc: null,
  ipsProfileList: [],
  ipsInBoundList: [],
  ipsOutBoundList: [],
  countryList: [],
  selectedCountryList: []
})

export const mutations = {
  clearStore (state) {
    state.pdForm = null
    state.selectedDeviceInfo = {}
    state.selectedPdData = []
    state.policyHostList = []
    state.popUpFunc = null
    state.ipsProfileList = []
    state.ipsInBoundList = []
    state.ipsOutBoundList = []
    state.countryList = []
    state.selectedCountryList = []
  },
  setSelectedCountryList  (state, param) {
    state.selectedCountryList = param
  },
  setCountryList  (state, {geoData, isOpen}) {
    if (isOpen) state.countryList = []
    for (const item of geoData) {
      if (item.name) {
        item.geo_country_full = item.name
        delete item.name
      }
      if (item.code) {
        item.geo_country_code = item.code
        delete item.code
      }
      state.countryList.push({code: item.geo_country_code, name: (item.geo_country_full ? item.geo_country_full : item.name)})
    }
    if (isOpen) {
      const codes = state.pdForm.pd_geo_country.map(item => item.code)
      const filterdArray = state.countryList.filter(item => !codes.includes(item.code))
      state.countryList = _.orderBy(filterdArray, 'name')
    } else {
      state.countryList = _.orderBy(state.countryList, 'name')
    }
    state.countryList = _.orderBy(state.countryList, 'name')
  },
  setSecurityTabSelectList (state, payload) {
    state.ipsProfileList = payload.ipsProfileList
    state.ipsInBoundList = payload.ipsInBoundList
    state.ipsOutBoundList = payload.ipsOutBoundList
  },
  setSelectedDeviceInfo (state, payload) {
    state.selectedDeviceInfo = payload
  },
  setFilteredPdList (state, payload) {
    if (_.get(payload, 'initFlag')) {
      const merged = applyActivationOption(payload)
      state.pdTableData = merged.list
      state.cntInfo = merged.cntInfo
      return
    }
    if (!_.get(payload, 'deleteFlag')) {
      state.pdTableData = payload.data
      return
    }
    const copy = state.pdTableData
    let i = _.size(copy)
    let foundCnt = 0

    const isBreakWhileFn = () => { // return true: break
      const pdId = _.get(copy[i], 'pd_id')
      if (!pdId) return false
      for (let j = 0; j < payload.data.length; j++) {
        if (pdId === payload.data[j]) {
          copy.splice(i, 1)
          foundCnt += 1
        }
      }
      if (foundCnt > 0 && foundCnt === payload.data.length) return true
      return false
    }

    while (i--) {
      if (isBreakWhileFn()) break
    }
    state.pdTableData = copy
  },
  resetFilteredPdList (state) {
    Object.keys(state.cntInfo).forEach(key => { state.cntInfo[key] = 0 })
    state.pdTableData = []
    state.policyViewFilter = 2
  },
  /** open protectionDomain Popup */
  triggerPopUp (state, payload) {
    state.popUpFunc = payload
  },
  copyPdFormTemplate (state, payload) {
    const newObj = Object.assign(pdDataTemplate, payload)

    state.pdForm = newObj
  },
  setReadOnly: (state, payload) => {
    state.storeReadOnly = payload
  },
  clearPdForm (state, payload) {
    Object.keys(state.pdForm).forEach(key => {
      const val = state.pdForm[key]
      if (typeof val === 'string') {
        state.pdForm[key] = ''
      } else if (typeof val === 'number') {
        if ([
          'pd_use',
          'pd_type',
          'pd_ips_sig_use',
          'pd_ips_ddos_use',
          'pd_port_awr_use'
        ].indexOf(key) > -1) {
          state.pdForm[key] = 1
        } else if (['pd_ips_prf_id1', 'pd_ips_prf_id2'].indexOf(key) > -1) {
          state.pdForm[key] = 0
        } else {
          if (!payload) {
            state.pdForm[key] = 0
          }
        }
      } else if (Array.isArray(val) && !payload) {
        state.pdForm[key] = []
      }
    })
    if (payload) {
      state.pdForm['pd_host'] = []
    }
  },
  updateForm (state, payload) {
    if (_.get(payload, 'option')) {
      delete state[payload.target][payload.key]
    } else {
      if (Array.isArray(payload)) { // 보안 설정(프로파일) > 프로파일
        payload.forEach(item => {
          _.set(state[item.target], item.key, item.val)
        })
      } else {
        _.set(state[payload.target], payload.key, payload.val)
      }
    }
    state[payload.target] = _.cloneDeep(state[payload.target])
  },
  clearPdData (state, payload) {
    if (payload) {
      state.selectedPdData = []
    } else {
      state.selectedPdData = []
      state.isSelectCell = false
      state.filteredPdDataList = []
      state.pdForm = null
    }
  },
  setSelectCell (state, payload) {
    state.isSelectCell = payload
  },
  resetSelectedPdData (state) {
    state.selectedPdData = []
  },
  /** table row selection */
  setSelectedPdData (state, payload) {
    state.selectedPdData = payload
  },
  /** setPdForm */
  setPdForm (state, payload) {
    if (payload.data.pd_ips_prf_id1 === null) {
      payload.data.pd_ips_prf_id1 = 0
    }
    if (payload.data.pd_ips_prf_id2 === null) {
      payload.data.pd_ips_prf_id2 = 0
    }
    state.pdForm = payload.data
  },
  setPolicyViewFilter (state, payload) {
    state.policyViewFilter = payload
  },
  setBluemaxModelType (state, payload) {
    state.bluemaxModelType = payload
  }
}

export const actions = {
  async fetchGeoCountryList ({commit, state}, payload) {
    const modelType = payload === 'ips' ? 21 : 23
    // 현재 정책 도메인에서는 Ipv4와 국가만 지원 국가 타입과 ip타입 지원하게 되면 api 파라미터 변경 필요
    const res = await this.$axios.$get(`${urlPrefix}/geo/countries?device_model_type=${modelType}&ip_type=1&geo_type=2`, {
      loading: false,
      isNotAlert: true
    })
    commit('setCountryList', {geoData: res.result, isOpen: true})
    return _.get(res, 'result')
  },
  async fetchIpsProfile ({commit, state}, payload) {
    // commit('setCountryList', filterAppCntry)
    const modelType = payload.bluemaxModelType === 'ads' ? '/ads' : ''
    const res = await this.$axios.$get(`${urlPrefix}${modelType}/protection-domain/policies/available-ips-prf`, {
      loading: false,
      isNotAlert: true
    })
    return _.get(res, 'result')
  },
  async fetchPdDataList ({commit, state}, {deviceId = null, bluemaxModelType, loading = true, isNotAlert = false} = {}) {
    const modelType = bluemaxModelType === 'ads' ? '/ads' : ''
    const {code, result} = await this.$axios.$get(`${urlPrefix}${modelType}/protection-domain/policies-all/${deviceId}`, {loading, isNotAlert})

    if (code === 'ok') {
      // filterDefaultVal => 2: showAll
      commit('setFilteredPdList', {data: result, filter: 2, initFlag: true, bluemaxModelType: bluemaxModelType})
      return true
    }
    return result
  },
  /**
   * POST or PUT request
   */
  async updatePdData ({commit, state}, {data = {}, action = 'edit', bluemaxModelType, loading = false, successAlert = false} = {}) {
    const modelType = bluemaxModelType === 'ads' ? '/ads' : ''
    const {code, result} = action === 'add'
      ? await this.$axios.$post(`${urlPrefix}${modelType}/protection-domain/policies`, data)
      : await this.$axios.$put(`${urlPrefix}${modelType}/protection-domain/policies`, data, {loading, successAlert})

    if (code === 'ok') {
      return true
    }
    return result
  },
  async deletePdData ({commit, state}, payload) {
    const modelType = payload.bluemaxModelType === 'ads' ? '/ads' : ''
    const res = await this.$axios.$delete(`${urlPrefix}${modelType}/protection-domain/policies`, {data: payload.idList})
    const result = _.get(res, 'result')
    const errList = _.get(result, 'errors')

    let targetArr = []

    if (!errList) {
      targetArr = payload.idList.pd_id_list.map(x => x.pd_id)
      commit('setFilteredPdList', {data: targetArr, filter: 2, deleteFlag: true, bluemaxModelType: payload.bluemaxModelType})
      return true
    }
    // 에러 처리
    if (payload.idList.pd_id_list.length !== _.size(errList)) {
      payload.idList.pd_id_list.forEach(x => {
        for (let i = 0; i < errList.length; i++) {
          if (errList[i].pd_id !== x.pd_id) {
            targetArr.length += 1
            targetArr[targetArr.length - 1] = x.pd_id
            break
          }
        }
      })
      commit('setFilteredPdList', {data: targetArr, filter: 2, deleteFlag: true, bluemaxModelType: payload.bluemaxModelType})
    }
    return result
  },
  async finalCommand ({state}, payload) {
    const modelType = payload.bluemaxModelType === 'ads' ? '/ads' : ''
    const {code, result} = await this.$axios.$put(`${urlPrefix}${modelType}/protection-domain/${payload.command}`, null, {loading: false, successAlert: false})

    if (code === 'ok') {
      return true
    }
    return result
  }
}

export const getters = {}
